var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 82.939 32.54 c -2.685 0 -5.092 -1.544 -6.326 -3.929 c -0.246 -0.475 -0.504 -0.948 -0.774 -1.416 c -0.27 -0.468 -0.55 -0.928 -0.839 -1.378 c -1.448 -2.26 -1.582 -5.118 -0.24 -7.443 l 0 0 c 1.95 -3.377 0.793 -7.695 -2.584 -9.645 l -9.353 -5.4 c -3.377 -1.95 -7.695 -0.793 -9.645 2.584 l -0.002 0.003 c -1.323 2.291 -3.814 3.641 -6.456 3.512 c -1.148 -0.056 -2.301 -0.056 -3.455 0 c -2.637 0.128 -5.123 -1.226 -6.443 -3.513 l -0.001 -0.002 c -1.95 -3.377 -6.268 -4.534 -9.645 -2.585 l -9.353 5.4 c -3.377 1.95 -4.534 6.268 -2.584 9.645 l 0.001 0.002 c 1.32 2.287 1.25 5.116 -0.179 7.336 c -0.625 0.971 -1.201 1.97 -1.727 2.992 c -1.209 2.353 -3.624 3.835 -6.27 3.835 H 7.061 C 3.161 32.54 0 35.701 0 39.6 V 50.4 c 0 3.9 3.161 7.061 7.061 7.061 l 0 0 c 2.685 0 5.092 1.544 6.326 3.929 c 0.246 0.475 0.504 0.947 0.774 1.416 c 0.27 0.468 0.55 0.928 0.839 1.378 c 1.448 2.26 1.582 5.118 0.24 7.443 c -1.95 3.377 -0.793 7.695 2.584 9.645 l 9.353 5.4 c 3.377 1.95 7.695 0.793 9.645 -2.584 l 0.002 -0.003 c 1.323 -2.291 3.814 -3.641 6.456 -3.512 c 1.148 0.056 2.301 0.056 3.455 0.001 c 2.637 -0.128 5.123 1.226 6.443 3.513 l 0.001 0.002 c 1.95 3.377 6.268 4.534 9.645 2.584 l 9.353 -5.4 c 3.377 -1.95 4.534 -6.268 2.584 -9.645 l -0.001 -0.002 c -1.32 -2.286 -1.25 -5.116 0.179 -7.336 c 0.625 -0.971 1.201 -1.97 1.727 -2.992 c 1.209 -2.353 3.624 -3.835 6.27 -3.835 h 0.003 c 3.9 0 7.061 -3.161 7.061 -7.061 L 90 39.6 C 90 35.701 86.839 32.54 82.939 32.54 z M 45 73.124 c -15.508 0 -28.125 -12.617 -28.125 -28.125 S 29.491 16.875 45 16.875 c 15.508 0 28.125 12.617 28.125 28.125 S 60.508 73.124 45 73.124 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgba(121,99,78,1)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.998000000000005,
    cy: 40.66799999999999,
    r: 8.508,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgba(121,99,78,1)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.639 67.863 c 1.072 -8.072 8.001 -14.32 16.361 -14.32 c 8.361 0 15.289 6.248 16.361 14.321 C 50.453 78.262 39.546 78.262 28.639 67.863 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgba(121,99,78,1)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.1f98d33dbb21ef04041ff6b00f427cf5.svg";
export { ForwardRef as ReactComponent };